import { z } from 'zod';

import { PaginationSchema } from '../../../pagination.js';

const taxonomySlug = z
  .string()
  .trim()
  .min(1)
  .max(100)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);

export const RegisterServiceTypeBodySchema = z.object({
  name: z.string().trim().min(1).max(255),
  slug: taxonomySlug,
});

export const RegisterServiceTypeResponseSchema = z.object({
  serviceTypeId: z.uuid(),
});

export const UpdateServiceTypeBodySchema = z
  .object({
    name: z.string().trim().min(1).max(255).optional(),
    slug: taxonomySlug.optional(),
  })
  .refine((body) => Object.keys(body).length > 0, { message: 'At least one field is required' });

export const ArchiveServiceTypeBodySchema = z.object({
  reason: z.string().trim().max(500).optional(),
});

export const ListServiceTypesQuerySchema = PaginationSchema;

export const ServiceTypeListItemSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const ListServiceTypesResponseSchema = z.object({
  items: z.array(ServiceTypeListItemSchema),
  pagination: z.object({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
  }),
});

export type RegisterServiceTypeBody = z.infer<typeof RegisterServiceTypeBodySchema>;
export type RegisterServiceTypeResponse = z.infer<typeof RegisterServiceTypeResponseSchema>;
export type UpdateServiceTypeBody = z.infer<typeof UpdateServiceTypeBodySchema>;
export type ArchiveServiceTypeBody = z.infer<typeof ArchiveServiceTypeBodySchema>;
export type ListServiceTypesQuery = z.infer<typeof ListServiceTypesQuerySchema>;
export type ListServiceTypesResponse = z.infer<typeof ListServiceTypesResponseSchema>;
